import { useEffect, useState } from "react";
import { FileText, LayoutGrid, Sparkles, Workflow, HelpCircle, Mail } from "lucide-react";
import logoAceleraMais from "@/assets/logo-acelera-mais.png";

const NAV_ITEMS = [
  { label: "Formulário", href: "#formulario", Icon: FileText },
  { label: "Estrutura", href: "#estrutura", Icon: LayoutGrid },
  { label: "Diferencial", href: "#diferencial", Icon: Sparkles },
  { label: "Método", href: "#metodo", Icon: Workflow },
  { label: "FAQ", href: "#faq", Icon: HelpCircle },
];

export default function Navbar() {
  const [compact, setCompact] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setCompact(window.scrollY > window.innerHeight * 0.85);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div
      className={`fixed inset-x-0 top-4 z-50 flex items-center justify-between gap-2 px-3 font-poppins text-white transition-all duration-500 ease-out lg:top-8 lg:gap-0 lg:px-12 xl:px-16 ${
        compact ? "lg:top-4" : ""
      }`}
    >
      {/* Logo */}
      <a
        href="#"
        aria-label="Acelera Mais"
        className={`flex items-center transition-all duration-500 ease-out h-9 ${
          compact ? "lg:h-12" : "lg:h-20"
        }`}
      >
        <img
          src={logoAceleraMais}
          alt="Acelera Mais"
          className="h-full w-auto object-contain drop-shadow-[0_4px_16px_rgba(0,0,0,0.4)]"
        />
      </a>

      {/* Glass Navbar */}
      <nav className="min-w-0">
        <ul
          className={`flex items-center rounded-full border border-white/15 bg-white/[0.04] shadow-[inset_0_1px_0_rgba(255,255,255,0.08),0_8px_32px_rgba(0,0,0,0.25)] backdrop-blur-md backdrop-saturate-150 transition-all duration-500 ease-out gap-0 p-0.5 lg:p-1.5 ${
            compact ? "lg:gap-0.5 lg:p-1" : "lg:gap-1 lg:p-1.5"
          }`}
        >
          {NAV_ITEMS.map(({ label, href, Icon }) => (
            <li key={href}>
              <a
                href={href}
                aria-label={label}
                title={label}
                className={`flex items-center justify-center rounded-full font-medium text-white/85 transition-all duration-500 ease-out hover:bg-white/10 hover:text-white h-8 w-8 ${
                  compact ? "lg:h-10 lg:w-10" : "lg:h-auto lg:w-auto lg:px-5 lg:py-2.5 lg:text-sm"
                }`}
              >
                <Icon
                  className={`shrink-0 transition-all duration-500 ease-out h-4 w-4 opacity-100 ${
                    compact ? "lg:h-5 lg:w-5" : "lg:h-0 lg:w-0 lg:opacity-0"
                  }`}
                />
                <span
                  className={`overflow-hidden whitespace-nowrap transition-all duration-500 ease-out max-w-0 opacity-0 ${
                    compact ? "lg:max-w-0 lg:opacity-0" : "lg:max-w-[200px] lg:opacity-100"
                  }`}
                >
                  {label}
                </span>
              </a>
            </li>
          ))}
        </ul>
      </nav>

      {/* CTA */}
      <a
        href="#formulario"
        aria-label="Entrar em contato"
        className={`flex items-center justify-center rounded-full border border-white/15 bg-white/[0.04] font-medium text-white/90 shadow-[inset_0_1px_0_rgba(255,255,255,0.08),0_8px_32px_rgba(0,0,0,0.25)] backdrop-blur-md backdrop-saturate-150 transition-all duration-500 ease-out hover:bg-white/10 hover:text-white h-9 w-9 shrink-0 ${
          compact ? "lg:h-10 lg:w-10" : "lg:h-auto lg:w-auto lg:px-6 lg:py-3 lg:text-sm"
        }`}
      >
        <Mail
          className={`shrink-0 transition-all duration-500 ease-out h-4 w-4 opacity-100 ${
            compact ? "lg:h-5 lg:w-5" : "lg:h-0 lg:w-0 lg:opacity-0"
          }`}
        />
        <span
          className={`overflow-hidden whitespace-nowrap transition-all duration-500 ease-out max-w-0 opacity-0 ${
            compact ? "lg:max-w-0 lg:opacity-0" : "lg:max-w-[200px] lg:opacity-100"
          }`}
        >
          Entrar em contato
        </span>
      </a>
    </div>
  );
}
